// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const messageBroadcast_donateText = (i) => `<b class="font-semibold">Sending SMS and emails costs us money</b>, so we'd appreciate a €1 donation per message.`